class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    // if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
    const currentFilter = event ? event.target.closest('.js-filter') : undefined;
    const shouldRenderCurrentFilter = currentFilter?.dataset.autoApplyAvailability === 'true';
    const matchesIndex = (element) => {
      return currentFilter ? element.dataset.index === currentFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => {
      if (shouldRenderCurrentFilter) return true;
      return !matchesIndex(element);
    });
    const countsToRender = shouldRenderCurrentFilter ? null : Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const filterElement = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);

      if (!filterElement) return;

      const isDisabled = element.classList.contains('is-disabled');
      const isOpen = filterElement.hasAttribute('open');

      if (!isDisabled) {
        filterElement.classList.remove('is-disabled');
        filterElement.innerHTML = element.innerHTML;
        if (isOpen) {
          filterElement.setAttribute('open', '');
          const summary = filterElement.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', true);
        }
      } else {
        filterElement.classList.add('is-disabled');
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender && currentFilter) FacetFiltersForm.renderCounts(countsToRender, currentFilter);
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  static isSizeFilterParam(paramName) {
    if (!paramName || !paramName.includes('.option.')) return false;

    const optionName = paramName.split('.option.').pop();
    return /size|tamanho/i.test(optionName);
  }

  static getAvailabilityParamName(formData, form) {
    const availabilityInput = form?.querySelector('input[name="filter.v.availability"], input[name="filter.p.availability"]');
    if (availabilityInput) return availabilityInput.name;

    for (const [name] of formData.entries()) {
      const match = name.match(/^filter\.([vp])\./);
      if (match) return `filter.${match[1]}.availability`;
    }

    return 'filter.v.availability';
  }

  static appendAvailabilityForSize(formData, form) {
    const checkedInputs = Array.from(form.querySelectorAll('input:checked'));
    const hasSelectedSizeFilter = checkedInputs.some((input) => {
      const filterElement = input.closest('.js-filter');
      if (filterElement?.dataset.autoApplyAvailability === 'true') return true;

      return FacetFiltersForm.isSizeFilterParam(input.name);
    });

    if (!hasSelectedSizeFilter) return;

    const availabilityParamName = FacetFiltersForm.getAvailabilityParamName(formData, form);
    if (formData.has(availabilityParamName)) return;

    formData.append(availabilityParamName, '1');
  }

  static ensureAvailabilitySearchParams(searchParams) {
    const params = new URLSearchParams(searchParams);
    const hasSelectedSizeFilter = Array.from(params.keys()).some((name) => FacetFiltersForm.isSizeFilterParam(name));

    if (!hasSelectedSizeFilter) return params.toString();

    const availabilityParamName = FacetFiltersForm.getAvailabilityParamName(params);
    if (params.has(availabilityParamName)) return params.toString();

    params.append(availabilityParamName, '1');
    return params.toString();
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const form = event.target.closest('form');
    const formData = new FormData(form);
    FacetFiltersForm.appendAvailabilityForSize(formData, form);
    const searchParams = FacetFiltersForm.ensureAvailabilitySearchParams(new URLSearchParams(formData).toString());
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    const searchParams = FacetFiltersForm.ensureAvailabilitySearchParams(url);
    FacetFiltersForm.renderPage(searchParams);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define('facet-remove', FacetRemove);

class DetailsHolder extends HTMLElement {
  constructor() {
    super();
    this.container = document.querySelector('.js-facets-desktop');
    this.mainDetailsToggle = this.querySelector('details');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.container.querySelectorAll('.facets__summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
  }

  handleBodyClick(event) {
    const target = event.target;
    const isNotDetails = target !== this.mainDetailsToggle;
    const isNotDetailsElement =  !target.closest('details-holder');

    if (isNotDetails && isNotDetailsElement) {
      const holder = target.closest('details-holder');
      this.activeElement = holder ? holder.querySelector('summary') : null;
      this.close();
    }
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    setTimeout(() => {
      this.container.querySelectorAll('details').forEach(details => {
        if (details !== detailsElement) {
          details.removeAttribute('open');
          details.querySelector('summary').setAttribute('aria-expanded', false);
        }
      });

      document.body.addEventListener('click', this.onBodyClick);
    });
  }

  close() {
    this.container.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.querySelector('summary').setAttribute('aria-expanded', false);
    });

    document.body.removeEventListener('click', this.onBodyClick);
  }
}

customElements.define('details-holder', DetailsHolder);
